import { useIntl } from '@weenat/wintl';
import isEmpty from 'lodash-es/isEmpty';
import isNil from 'lodash-es/isNil';
import { getWarningThresholdsFromBrand } from '../../enums/Devices';
import fromBrandEnumToLabel from '../devices/fromBrandEnumToLabel';
import { isDevice } from '../utils/resourcesTypeCheckers';
// TODO: ask back end to handle that case
const VIRTUAL_METRICS = ['T_DEW', 'etp'];
export const getIsVirtualDeviceAndMeasurementConfig = ({ resource, metric }) => {
    const isResourceDefined = !isNil(resource);
    const isResourceAPlot = isResourceDefined && 'currentMeasurementConfigs' in resource;
    const measurementConfig = isResourceAPlot
        ? resource.currentMeasurementConfigs.find((c) => c.metric === metric)
        : null;
    return {
        isVirtualDevice: VIRTUAL_METRICS.includes(metric) ||
            (!isNil(measurementConfig) && isNil(measurementConfig.deviceId)),
        measurementConfig
    };
};
/**
 * Hook returning details about the device or virtual device providing the metric to the given resource
 */
const useMetricProvider = ({ resource, metric, isExpertOrg }) => {
    const { t } = useIntl();
    let deviceId = undefined;
    if (isNil(resource)) {
        return { name: undefined, isVirtualDevice: false, warningThreshold: undefined, deviceId };
    }
    else {
        const isCompleteResource = 'kind' in resource;
        const { isVirtualDevice, measurementConfig } = getIsVirtualDeviceAndMeasurementConfig({
            resource,
            metric
        });
        const isAStation = 'deviceId' in resource;
        const isADevice = isCompleteResource ? isDevice(resource) : 'availableMeasures' in resource;
        if (isAStation) {
            deviceId = resource.deviceId;
        }
        else if (isADevice) {
            deviceId = resource.id;
        }
        else if (!isNil(measurementConfig)) {
            deviceId = measurementConfig.deviceId ?? undefined;
        }
        const brand = measurementConfig?.brand;
        const model = measurementConfig?.model;
        let finalModel = model;
        if ('model' in resource) {
            finalModel = resource.model;
        }
        let finalBrand = brand;
        if ('brand' in resource) {
            finalBrand = resource.brand;
        }
        const deviceBrand = fromBrandEnumToLabel(finalBrand);
        let name = `${deviceBrand} ${finalModel || ''}`.trim();
        if (metric === 'HDEF') {
            name = t('dss.waterBalance.arvalis_water_balance');
        }
        else if (isVirtualDevice) {
            name = isExpertOrg
                ? t('dataSources.meteo_vision', { capitalize: true })
                : t('dataSources.spatialized_weather', { capitalize: true });
        }
        else if (isEmpty(name)) {
            name = undefined;
        }
        const warningThreshold = getWarningThresholdsFromBrand(brand, metric);
        return { name, isVirtualDevice, warningThreshold, deviceId };
    }
};
export default useMetricProvider;
